import { Injectable } from '@angular/core';
import { HttpParams, HttpClient } from '@angular/common/http';

import { environment } from '../../../environments/environment';
import * as _ from 'lodash';
import { CalibrationSetTableFieldAttribute } from '../../models/calibrations/calibration-set-table-field-attribute.model';
import { AttributeService } from './attribute.service';
import { TableFieldOption, CalibrationSetType } from '../../../shared/enums';

const API = environment.ZONEIQ_CALIBRATION + '/v1/calibration-set-table-field-attribute';

@Injectable({
    providedIn: 'root'
})
export class CalibrationSetTableFieldAttributeService extends AttributeService<CalibrationSetTableFieldAttribute> {
    constructor(protected readonly http: HttpClient) {
        super(http, API, CalibrationSetTableFieldAttribute);
    }

    getAttributesForCalibrationSetTableField(
        calibrationSetId: number,
        calibrationSetType: CalibrationSetType,
        tableFieldId: number,
        tableFieldOption?: TableFieldOption
    ) {
        if (!calibrationSetId) {
            return;
        }

        const params = new HttpParams()
            .set('calibrationSetId', calibrationSetId.toString())
            .set('calibrationSetType', calibrationSetType.toString())
            .set('tableFieldId', tableFieldId.toString())
            .set('tableFieldOption', tableFieldOption.toString());

        return super.getByParameters(params);
    }
}
